import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { UserGoalApiModel } from '@app/api/api-models/goals/UserGoalApiModel';

@Injectable()
export class UserGoalsService extends CrudService<UserGoalApiModel, string> {
  public apiUrl = 'user-goals';

  public getUserGoals(userId: string): Observable<UserGoalApiModel[]> {
    return this.http.get<UserGoalApiModel[]>(`${this.apiUrl}/get-list/${userId}`);
  }
}
